import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  resetFilterData,
  setBMCWithRating,
  setBMCWithRatingGridCurrentPage,
  setFilterDataField,
} from "src/redux/slices/bmcWithRatingSlice";
import { Dropdown } from "primereact/dropdown";
import { getFieldName } from "src/utils/helpers";
import useOnPageLeave from "src/hooks/useOnPageLeave";
import ToggleFilter from "src/components/ToggleFilter/ToggleFilter";
import useResize from "src/hooks/useResize";
import { useEffect, useState } from "react";
import { useCallback } from "react";
import FilterActionButtons from "src/components/FilterActionButtons/FilterActionButtons";
import { MultiSelect } from "primereact/multiselect";
import { getInvoiceStatusOptions, getServiceTerritories, setServiceTerritories } from "src/redux/slices/lookupSlice";
import { ReactComponent as ExcellentIcon } from "src/assets/icons/excellent.svg";
import { ReactComponent as GoodIcon } from "src/assets/icons/good.svg";
import { ReactComponent as FairIcon } from "src/assets/icons/average.svg";
import { ReactComponent as WeakIcon } from "src/assets/icons/weak.svg";

const BMCWithRatingFilter = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["common", "registration"]);

  const { isMobile } = useResize();
  const [isFilterShown, setIsFilterShown] = useState(!isMobile);

  const { company, rating, territory, city } = useSelector(
    (state: any) => state.bmcWithRating.filterData
  );
  const bmcList = useSelector((state: any) => state.civilDefense.bmcList);

  const serviceTerritories = useSelector(
    (state: any) => state.lookup.serviceTerritories
  );
  const citiesOptions = useSelector((state: any) => state.lookup.citiesOptions);

  const language = useSelector((state: any) => state.lookup.language);
  const handleFormSubmit = (e: any) => {
    e.preventDefault();
  };

  useEffect(() => {
    dispatch(getInvoiceStatusOptions() as any);
  }, [dispatch]);

  const handleFilter = () => {
    goToGridFirstPage();
  };

  const handleFormFieldChange = (e: any) => {
    let name, value;
    if (e.target) {
      name = e.target.name;
      value = e.target.value;
    } else {
      name = e.name;
      value = e.value;
    }
    dispatch(setFilterDataField({ field: name, value }));
  };


  const handleCityChange = (e: any) => {
    handleFormFieldChange(e);
    dispatch(setFilterDataField({ field: "territory", value: '' }));
    dispatch(setServiceTerritories([]));
    dispatch(getServiceTerritories(false, e.value) as any);
  };

  const handleClearFilterForm = (): void => {
    dispatch(resetFilterData());
    dispatch(setServiceTerritories([]));
    goToGridFirstPage();
  };

  const goToGridFirstPage = useCallback(() => {
    dispatch(setBMCWithRatingGridCurrentPage(0));
  }, []);

  const onPageLeave = useCallback(() => {
    dispatch(resetFilterData());
    dispatch(setBMCWithRating({ data: [], totalRecords: 0 }));
  }, []);
  useOnPageLeave(onPageLeave);

  useOnPageLeave(resetFilterData);
  const toggleFilter = () => {
    setIsFilterShown(!isFilterShown);
  };
  const ratingOptions = [
    {
      ratingId: 0,
      ratingName: (
        <div className="d-flex gap-2 align-items-center">
          <WeakIcon />
          <span>{t("poor")}</span>
        </div>
      ),
    },
    {
      ratingId: 1,
      ratingName: (
        <div className="d-flex gap-2 align-items-center">
          <FairIcon />
          <span>{t("fair")}</span>
        </div>
      ),
    },
    {
      ratingId: 2,
      ratingName: (
        <div className="d-flex gap-2 align-items-center">
          <GoodIcon />
          <span>{t("good")}</span>
        </div>
      ),
    },
    {
      ratingId: 3,
      ratingName: (
        <div className="d-flex gap-2 align-items-center">
          <ExcellentIcon />
          <span>{t("excellent")}</span>
        </div>
      ),
    },
  ];
  return (
    <>
      <ToggleFilter onClick={toggleFilter} />
      <div
        className={`px-2 pb-2 pt-3 maintenance-requests-filter ${!isMobile || isFilterShown ? "d-flex" : "d-none"
          } ${isMobile ? "my-3" : ""} `}
      >
        <p className="d-flex m-0 me-2 mb-2 ms-2 fit-content filter-by-label">
          {t("filterBy")}
        </p>
        <form onSubmit={handleFormSubmit}>
          <div className="filter-row mb-2">
            <MultiSelect
              optionValue={"id"}
              optionLabel={"name"}
              value={company}
              onChange={handleFormFieldChange}
              options={bmcList}
              placeholder={t("bmcCompanyName")}
              id="companyId"
              name="company"
              className="status-dropdown"
              panelClassName="status-dropdown-panel"
              onHide={() => { }}
              filter
              resetFilterOnHide
            />
            <Dropdown
              id="city"
              value={city}
              name="city"
              options={citiesOptions}
              optionLabel={getFieldName(language)}
              optionValue="cityId"
              onChange={handleCityChange}
              required
              placeholder={t("selectCity")}
            />
            <MultiSelect
                filter
                resetFilterOnHide
                emptyMessage={t("noResultsFound")}
                emptyFilterMessage={t("noResultsFound")}
                options={city ? serviceTerritories : []}
                placeholder={t("territory") + " - " + t("selectCityFirstShort")}
                className="status-dropdown"
                optionValue={"territoryId"}
                optionLabel={getFieldName(language)}
                panelClassName="status-dropdown-panel"
                onChange={handleFormFieldChange}
                value={territory}
                name="territory"
              />
            <Dropdown
              resetFilterOnHide
              emptyFilterMessage={t("noResultsFound")}
              placeholder={t("rating")}
              className="system-name-dropdown"
              optionLabel={"ratingName"}
              panelClassName="status-dropdown-panel"
              onChange={handleFormFieldChange}
              optionValue="ratingId"
              value={rating}
              name="rating"
              options={ratingOptions}
            />
            <FilterActionButtons
              handleFilter={handleFilter}
              handleClear={handleClearFilterForm}
            />
          </div>
        </form>
      </div>
    </>
  );
};

export default BMCWithRatingFilter;
